import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { useSsrAdapter as Z } from "../../../../../../@css-render_vue3-ssr@0.15.14_vue@3.5.18/node_modules/@css-render/vue3-ssr/esm/index.js";
import X from "../../resize-observer/src/VResizeObserver.js";
import { ensureMaybeTouch as ee, ensureWheelScale as Y } from "./config.js";
import { setupXScroll as te } from "./xScroll.js";
import { VirtualListRow as $ } from "./VirtualListRow.js";
import { cssrAnchorMetaName as le, c as _ } from "../../shared/cssr.js";
import D from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-memo.js";
import { FinweckTree as ie } from "../../shared/finweck-tree.js";
import { depx as K, pxfy as w } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/css/index.js";
import { defineComponent as ne, onMounted as oe, onActivated as se, onDeactivated as re, computed as p, h as b, mergeProps as ue } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { beforeNextFrameOnce as ae } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/animation/next-frame-once.js";
import { toRef as O, ref as z } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const de = _(".v-vl", {
  maxHeight: "inherit",
  height: "100%",
  overflow: "auto",
  minWidth: "1px"
  // a zero width container won't be scrollable
}, [
  _("&:not(.v-vl--show-scrollbar)", {
    scrollbarWidth: "none"
  }, [
    _("&::-webkit-scrollbar, &::-webkit-scrollbar-track-piece, &::-webkit-scrollbar-thumb", {
      width: 0,
      height: 0,
      display: "none"
    })
  ])
]), pe = ne({
  name: "VirtualList",
  inheritAttrs: !1,
  props: {
    showScrollbar: {
      type: Boolean,
      default: !0
    },
    columns: {
      type: Array,
      default: () => []
    },
    renderCol: Function,
    renderItemWithCols: Function,
    items: {
      type: Array,
      default: () => []
    },
    // it is suppose to be the min height
    itemSize: {
      type: Number,
      required: !0
    },
    itemResizable: Boolean,
    itemsStyle: [String, Object],
    visibleItemsTag: {
      type: [String, Object],
      default: "div"
    },
    visibleItemsProps: Object,
    ignoreItemResize: Boolean,
    onScroll: Function,
    onWheel: Function,
    onResize: Function,
    defaultScrollKey: [Number, String],
    defaultScrollIndex: Number,
    keyField: {
      type: String,
      default: "key"
    },
    // Whether it is a good API?
    // ResizeObserver + footer & header is not enough.
    // Too complex for simple case
    paddingTop: {
      type: [Number, String],
      default: 0
    },
    paddingBottom: {
      type: [Number, String],
      default: 0
    }
  },
  setup(l) {
    const F = Z();
    de.mount({
      id: "vueuc/virtual-list",
      head: !0,
      anchorMetaName: le,
      ssr: F
    }), oe(() => {
      const { defaultScrollIndex: e, defaultScrollKey: t } = l;
      e != null ? E({ index: e }) : t != null && E({ key: t });
    });
    let S = !1, y = !1;
    se(() => {
      if (S = !1, !y) {
        y = !0;
        return;
      }
      E({ top: v.value, left: k.value });
    }), re(() => {
      S = !0, y || (y = !0);
    });
    const x = D(() => {
      if (l.renderCol == null && l.renderItemWithCols == null || l.columns.length === 0)
        return;
      let e = 0;
      return l.columns.forEach((t) => {
        e += t.width;
      }), e;
    }), f = p(() => {
      const e = /* @__PURE__ */ new Map(), { keyField: t } = l;
      return l.items.forEach((i, o) => {
        e.set(i[t], o);
      }), e;
    }), { scrollLeftRef: k, listWidthRef: W } = te({
      columnsRef: O(l, "columns"),
      renderColRef: O(l, "renderCol"),
      renderItemWithColsRef: O(l, "renderItemWithCols")
    }), u = z(null), d = z(void 0), m = /* @__PURE__ */ new Map(), h = p(() => {
      const { items: e, itemSize: t, keyField: i } = l, o = new ie(e.length, t);
      return e.forEach((s, r) => {
        const n = s[i], a = m.get(n);
        a !== void 0 && o.add(r, a);
      }), o;
    }), R = z(0), v = z(0), C = D(() => Math.max(h.value.getBound(v.value - K(l.paddingTop)) - 1, 0)), U = p(() => {
      const { value: e } = d;
      if (e === void 0)
        return [];
      const { items: t, itemSize: i } = l, o = C.value, s = Math.min(o + Math.ceil(e / i + 1), t.length - 1), r = [];
      for (let n = o; n <= s; ++n)
        r.push(t[n]);
      return r;
    }), E = (e, t) => {
      if (typeof e == "number") {
        B(e, t, "auto");
        return;
      }
      const { left: i, top: o, index: s, key: r, position: n, behavior: a, debounce: c = !0 } = e;
      if (i !== void 0 || o !== void 0)
        B(i, o, a);
      else if (s !== void 0)
        V(s, a, c);
      else if (r !== void 0) {
        const N = f.value.get(r);
        N !== void 0 && V(N, a, c);
      } else
        n === "bottom" ? B(0, Number.MAX_SAFE_INTEGER, a) : n === "top" && B(0, 0, a);
    };
    let I, H = null;
    function V(e, t, i) {
      const { value: o } = h, s = o.sum(e) + K(l.paddingTop);
      if (!i)
        u.value.scrollTo({
          left: 0,
          top: s,
          behavior: t
        });
      else {
        I = e, H !== null && window.clearTimeout(H), H = window.setTimeout(() => {
          I = void 0, H = null;
        }, 16);
        const { scrollTop: r, offsetHeight: n } = u.value;
        if (s > r) {
          const a = o.get(e);
          s + a <= r + n || u.value.scrollTo({
            left: 0,
            top: s + a - n,
            behavior: t
          });
        } else
          u.value.scrollTo({
            left: 0,
            top: s,
            behavior: t
          });
      }
    }
    function B(e, t, i) {
      u.value.scrollTo({
        left: e,
        top: t,
        behavior: i
      });
    }
    function q(e, t) {
      var i, o, s;
      if (S || l.ignoreItemResize || P(t.target))
        return;
      const { value: r } = h, n = f.value.get(e), a = r.get(n), c = (s = (o = (i = t.borderBoxSize) === null || i === void 0 ? void 0 : i[0]) === null || o === void 0 ? void 0 : o.blockSize) !== null && s !== void 0 ? s : t.contentRect.height;
      if (c === a)
        return;
      c - l.itemSize === 0 ? m.delete(e) : m.set(e, c - l.itemSize);
      const T = c - a;
      if (T === 0)
        return;
      r.add(n, T);
      const g = u.value;
      if (g != null) {
        if (I === void 0) {
          const A = r.sum(n);
          g.scrollTop > A && g.scrollBy(0, T);
        } else if (n < I)
          g.scrollBy(0, T);
        else if (n === I) {
          const A = r.sum(n);
          c + A > // Note, listEl shouldn't have border, nor offsetHeight won't be
          // correct
          g.scrollTop + g.offsetHeight && g.scrollBy(0, T);
        }
        M();
      }
      R.value++;
    }
    const j = !ee();
    let L = !1;
    function G(e) {
      var t;
      (t = l.onScroll) === null || t === void 0 || t.call(l, e), (!j || !L) && M();
    }
    function J(e) {
      var t;
      if ((t = l.onWheel) === null || t === void 0 || t.call(l, e), j) {
        const i = u.value;
        if (i != null) {
          if (e.deltaX === 0 && (i.scrollTop === 0 && e.deltaY <= 0 || i.scrollTop + i.offsetHeight >= i.scrollHeight && e.deltaY >= 0))
            return;
          e.preventDefault(), i.scrollTop += e.deltaY / Y(), i.scrollLeft += e.deltaX / Y(), M(), L = !0, ae(() => {
            L = !1;
          });
        }
      }
    }
    function Q(e) {
      if (S || P(e.target))
        return;
      if (l.renderCol == null && l.renderItemWithCols == null) {
        if (e.contentRect.height === d.value)
          return;
      } else if (e.contentRect.height === d.value && e.contentRect.width === W.value)
        return;
      d.value = e.contentRect.height, W.value = e.contentRect.width;
      const { onResize: t } = l;
      t !== void 0 && t(e);
    }
    function M() {
      const { value: e } = u;
      e != null && (v.value = e.scrollTop, k.value = e.scrollLeft);
    }
    function P(e) {
      let t = e;
      for (; t !== null; ) {
        if (t.style.display === "none")
          return !0;
        t = t.parentElement;
      }
      return !1;
    }
    return {
      listHeight: d,
      listStyle: {
        overflow: "auto"
      },
      keyToIndex: f,
      itemsStyle: p(() => {
        const { itemResizable: e } = l, t = w(h.value.sum());
        return R.value, [
          l.itemsStyle,
          {
            boxSizing: "content-box",
            width: w(x.value),
            height: e ? "" : t,
            minHeight: e ? t : "",
            paddingTop: w(l.paddingTop),
            paddingBottom: w(l.paddingBottom)
          }
        ];
      }),
      visibleItemsStyle: p(() => (R.value, {
        transform: `translateY(${w(h.value.sum(C.value))})`
      })),
      viewportItems: U,
      listElRef: u,
      itemsElRef: z(null),
      scrollTo: E,
      handleListResize: Q,
      handleListScroll: G,
      handleListWheel: J,
      handleItemResize: q
    };
  },
  render() {
    const { itemResizable: l, keyField: F, keyToIndex: S, visibleItemsTag: y } = this;
    return b(X, {
      onResize: this.handleListResize
    }, {
      default: () => {
        var x, f;
        return b("div", ue(this.$attrs, {
          class: ["v-vl", this.showScrollbar && "v-vl--show-scrollbar"],
          onScroll: this.handleListScroll,
          onWheel: this.handleListWheel,
          ref: "listElRef"
        }), [
          this.items.length !== 0 ? b("div", {
            ref: "itemsElRef",
            class: "v-vl-items",
            style: this.itemsStyle
          }, [
            b(y, Object.assign({
              class: "v-vl-visible-items",
              style: this.visibleItemsStyle
            }, this.visibleItemsProps), {
              default: () => {
                const { renderCol: k, renderItemWithCols: W } = this;
                return this.viewportItems.map((u) => {
                  const d = u[F], m = S.get(d), h = k != null ? b($, {
                    index: m,
                    item: u
                  }) : void 0, R = W != null ? b($, {
                    index: m,
                    item: u
                  }) : void 0, v = this.$slots.default({
                    item: u,
                    renderedCols: h,
                    renderedItemWithCols: R,
                    index: m
                  })[0];
                  return l ? b(X, {
                    key: d,
                    onResize: (C) => this.handleItemResize(d, C)
                  }, {
                    default: () => v
                  }) : (v.key = d, v);
                });
              }
            })
          ]) : (f = (x = this.$slots).empty) === null || f === void 0 ? void 0 : f.call(x)
        ]);
      }
    });
  }
});
export {
  pe as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vueuc@0.4.64_vue@3.5.18/~/vueuc/es/virtual-list/src/VirtualList.js
// module id = 206
// module chunks = 41